import { ToggleButton, ToggleButtonGroup, Autocomplete, TextField, IconButton } from "@mui/material";
import React, { useState, useEffect } from "react";
import WeeklyScheduleView from "./WeeklyScheduleView"
import HourlyScheduleView from "./HourlyScheduleView"
import DiaryScheduleView from "./DiaryScheduleView"
import { AddCircle, ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import ScheduleBlockAddModal from "./ScheduleBlockAddModal";

const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]
const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

Date.prototype.GetFirstDayOfWeek = function() {
	console.log(this.getDay())
    let firstDay= new Date(this.setDate(this.getDate() - this.getDay() + (this.getDay() == 0 ? -7:0) ));
	firstDay.setHours(0, 0, 0, 0)

	return firstDay;
}
Date.prototype.GetLastDayOfWeek = function() {
    let lastDay = new Date(this.setDate(this.getDate() - this.getDay() + 6));
	lastDay.setHours(0, 0, 0, 0)

	return lastDay;
}

Date.prototype.GetToday = function() {
    let today = new Date(this.setDate(this.getDate()));
	today.setHours(0, 0, 0, 0)

	return today;
}

Date.prototype.GetTomorrow = function() {
    let tomorrow = new Date(this.setDate(this.getDate() + 1));
	tomorrow.setHours(0, 0, 0, 0)

	return tomorrow;
}

const ScheduleView = (props) => {
	let [viewMode, setViewMode] = useState(width < 400 ? 'diary' : props.viewMode || 'day');
	let [dateRange, setDateRange] = useState();
	let [events, setEvents] = useState();

	let [filteredEvents, setFilteredEvents] = useState();
	let [selectedSchedule, setSelectedSchedule] = useState();

	let [selectedEvent, setSelectedEvent] = useState();
	let [addToSchedule, setAddToSchedule] = useState();
	let [selectedHour, setSelectedHour] = useState();
	let [openModal, setOpenModal] = useState(props.openModal);

	let [associateMode, setAssociateMode] = useState(false);
	let [allSchedules, setAllSchedules] = useState([]);

	useEffect(() => {
		if (viewMode === "week") {
			var curr = new Date(); 
			curr = new Date(curr.getTime() - curr.getTimezoneOffset() * 60000 )
			setDateRange([curr.GetFirstDayOfWeek(), curr.GetLastDayOfWeek()]);
		} else if (viewMode === "day" || viewMode === "diary") {
			var curr = new Date();
			curr = new Date(curr.getTime() - curr.getTimezoneOffset() * 60000 )
			curr.setHours(0,0,0,0)
			setDateRange([curr.GetToday(), curr.GetTomorrow()]);
		}
	},[viewMode]);

	useEffect(() => {
		if (props.schedules && props.schedules.length > 0) {
			let index = 0;
			let events = []
			console.log(dateRange)
			props.schedules.forEach(s => {
				s.blocks && s.blocks.forEach(b => {
					if (b.type === "Event") {
						//This is just an event, so a one time deal
						
						let eventDate = new Date(b.event_date);
						eventDate = new Date(eventDate.getTime() + eventDate.getTimezoneOffset() * 60000 )

						if (dateRange[0] <= eventDate && dateRange[1] > eventDate) {
							let event = Object.assign({}, b);
							event.day_of_week = eventDate.getDay()
							events.push(event)
						}
					} else {
						//We have a repeating event, so we'll need to make multiple events that parallel 
						//the normal event above
						let startDate = b.start_date ? new Date(b.start_date) : null;
						let endDate = b.end_date ? new Date(b.end_date) : null;

						let isValid = true;
						if (startDate && (startDate > new Date())) isValid = false;
 						if (endDate && (endDate < new Date())) isValid = false;

						if (isValid) {
							let dateIter = new Date(dateRange[0])
							while (dateIter <= dateRange[1]) {
						
								let dayOfWeek = dateIter.getDay()
								if (b.days.find(d => d == days[dayOfWeek])) {
									let event = Object.assign({}, b);
									event.event_date = dateIter;
									event.day_of_week = dayOfWeek;

									//This should be simpler but I've gone back and forth 100 times and I give up
									if (viewMode === 'week' && dateRange[0] <= event.event_date && dateRange[1] >= event.event_date) {
										events.push(event)
									} else if ((viewMode === 'day' || viewMode === 'diary') && dateRange[0] <= event.event_date && dateRange[1] > event.event_date) {
										events.push(event)
									}
								} 

								dateIter.setDate(dateIter.getDate() + 1)
							}
						}
					}
				})


				index++;
			})

			console.log(events)
			setEvents(events)
		}
	}, [props.schedules, dateRange])

	useEffect(() => {
		if (selectedSchedule && events) {
			setFilteredEvents(events.filter(e => e.schedule_id == selectedSchedule.id))
		} else setFilteredEvents(null)
	},[selectedSchedule])

	useEffect(() => {
		setOpenModal(props.openModal)
	}, [props.openModal])

	const setMode = (e) => {
		setViewMode(e.target.value)
	}

	const previous = () => {
		viewMode === "week" ? prevWeek() : prevDay()
	}

	const next = () => {
		viewMode === "week" ? nextWeek() : nextDay()
	}

	const prevDay = () => {
		var curr = dateRange[0]
		let yesterday = new Date(curr)
		yesterday = new Date(yesterday.setDate(curr.getDate() - 1))
		console.log(yesterday.toLocaleDateString())
		console.log(curr.toLocaleDateString())

		setDateRange([yesterday, curr]);
	}

	const prevWeek = () => {
		var curr = new Date(dateRange[0])
		let lastWeek = new Date(curr.setDate(curr.getDate() - 7))
		setDateRange([lastWeek.GetFirstDayOfWeek(), lastWeek.GetLastDayOfWeek()]);
	}


	const nextDay = () => {
		var curr = dateRange[0]
		let tomorrow = new Date()
		tomorrow = new Date(tomorrow.setDate(curr.getDate() + 1))
		console.log(curr.toLocaleDateString())

		setDateRange([tomorrow, new Date(curr.setDate(curr.getDate() + 2))]);
	}

	const nextWeek = () => {
		var curr = new Date(dateRange[0])
		let nextWeek = new Date(curr.setDate(curr.getDate() + 8))
		setDateRange([nextWeek.GetFirstDayOfWeek(), nextWeek.GetLastDayOfWeek()]);
	}


	const showModal = (event) => {
		setSelectedEvent(event);
		setOpenModal(true);
	}

	const openModalClick = (schedule, hour) => {
		if (props.isEditable) {
			setAddToSchedule(schedule);
			setSelectedEvent(null);
			setOpenModal(true);
			setSelectedHour(hour);
		}
	}

	const associateSchedule = (schedule) => {
		props.linkToEntity(schedule);
		setAssociateMode(false);
	}

    return (
    	<div className="schedule-view">  
			<ScheduleBlockAddModal 
				open={openModal} 
				schedules={props.schedules} 
				event={selectedEvent} 
				addSchedule={props.addSchedule}
				addNewScheduleBlock={props.addNewScheduleBlock} 
				editScheduleBlock={props.editScheduleBlock} 
				deleteBlock={props.deleteBlock}
				selectedSchedule={addToSchedule}
				startHour={selectedHour} 
				isEditable={props.canEditSchedule}
				closeCallback={() => setOpenModal(false)} 
			/>
		<div className="section-header">{props.header}</div>
			{
			props.schedules && props.schedules.length > 0 ?
            	<div>
					<div className="schedule-view-selector">
						{ viewMode !== 'diary' ?
							<ToggleButtonGroup
									value={viewMode}
									exclusive
									size="small"
									onChange={setMode}
								>
								<ToggleButton value="week">Weekly</ToggleButton>
								<ToggleButton value="day">Hourly</ToggleButton>
							</ToggleButtonGroup> : null
						}
						{
							viewMode === "week" || viewMode === "diary" ?
							<div className="schedule-filter">
								<Autocomplete
									disablePortal
									id="scheduleChooser"
									options={props.schedules}
									getOptionLabel={option => option.name}
									style={{ width: "250px" }}
									defaultValue={props.schedules && props.schedules.find(s => selectedSchedule && s.schedule_id === setSelectedSchedule.id)}
									renderInput={(params) => <TextField {...params} label="Filter by schedule" variant="outlined" size="small" />}
									onChange={(event, newValue) => {
										setSelectedSchedule(newValue)
									}}
								/>
							</div>
							: null
						}
					</div>

					<div className="schedule-view-header">
						<div className="schedule-prev">
							<ArrowBackIos onClick={previous} />
						</div>
						{
							dateRange ? 
									viewMode === "week" ? 
										<div className="schedule-date-range">
											{ dateRange[0].toLocaleDateString() } - { dateRange[1].toLocaleDateString() } 
										</div>
										:
										<div className="schedule-date">
											{ dateRange[0].toLocaleDateString() }
										</div>
									: null
						}
						<div className="schedule-next">
							<ArrowForwardIos onClick={next} />
						</div>
					</div>
					{
						viewMode === "week" ?
							<WeeklyScheduleView events={filteredEvents || events} showModal={showModal} /> 
							: 
							viewMode === "day" ?
							<HourlyScheduleView 
								schedules={props.schedules} 
								entitySchedules={props.entitySchedules}
								events={filteredEvents ||events} 
								showModal={showModal} 
								openModalClick={openModalClick} />
							:
							<DiaryScheduleView 
								schedules={props.schedules} 
								events={filteredEvents ||events} 
								showModal={showModal} 
								selectedSchedule={selectedSchedule}
								openModalClick={openModalClick} />
					}
				</div>
				:
				null
			}

			{
				props.linkToEntity ?
					associateMode ?
						<div className="bulk-add-prompt">
							<AddCircle style={{ fill: '#00b088', background: 'white' }} />
							<Autocomplete
								disablePortal
								id="associateSchedule"
								options={props.allSchedules}
								getOptionLabel={option => option.name}
								style={{ width: "250px" }}
								renderInput={(params) => <TextField {...params} label="Associate Schedule" variant="outlined" size="small" />}
								onChange={(event, newValue) => {
									associateSchedule(newValue)
								}}
							/>
						</div>
						:
						<div className="bulk-add-prompt">
							<IconButton
								variant="contained"
								color="primary"
								aria-label={'View and edit site settings'}
								onClick={() => {
									setAssociateMode(true);
								}}
								>
									<AddCircle style={{ fill: '#00b088', background: 'white' }} />
							</IconButton>
							{props.schedules && props.schedules.length > 0 ? "Link another schedule to this zone" : "Associate a schedule to this zone"}
						</div> 
				: null
			}

		</div>
        
    )
}

export default ScheduleView;